import { Heading, theme } from '@zappyrent/hundop';
import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';

import useStore from '../../../store';
import ModalContent from '../../Modal/ModalContent/ModalContent';
import ModalFooter from '../../Modal/ModalFooter/ModalFooter';
import {
  StyledModalHeader,
  StyledModalInnerWrapper,
} from '../../User/UserPayments/UserPayments.styles';
import {
  StyledBodyText,
  StyledButton,
  StyledButtonWrapper,
  StyledFlexWrapper,
  StyledSpinner,
} from './UpdatePaymentInformationModal.styles';

const UpdatePaymentInfoModal = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation([
    'payments',
    'form',
    'navigation',
    'common',
    'error',
  ]);
  const { user } = useStore(state => ({
    user: state.user,
  }));
  const navigate = useNavigate();
  const { locale } = useParams();
  const { mutateAsync, isLoading } = useMutation(async () => {
    onClose();
    navigate(`/${locale}/${t('navigation:profile')}`);
  });

  return (
    <StyledModalInnerWrapper>
      <StyledModalHeader>
        <Heading sm="20px" md="20px" lg="24px" tag="h1">
          {t('payments:confirmBankAccount')}
        </Heading>
      </StyledModalHeader>
      <ModalContent>
        <StyledBodyText>{upperFirst(t('payments:updateInfo'))}</StyledBodyText>
      </ModalContent>
      <ModalFooter>
        <StyledButtonWrapper>
          <br />
          <StyledFlexWrapper>
            <StyledButton
              user={user?.type ?? 'landlord'}
              onClick={() => mutateAsync()}
              disabled={isLoading}
            >
              {isLoading && (
                <StyledSpinner
                  foregroundColor={theme.colors.cross.ultralightGray}
                  size={15}
                  strokeSize={2}
                />
              )}
              {upperFirst(t('navigation:profile'))}
            </StyledButton>
          </StyledFlexWrapper>
        </StyledButtonWrapper>
      </ModalFooter>
    </StyledModalInnerWrapper>
  );
};

export default UpdatePaymentInfoModal;
